import {reducerFactory} from '../../lib/asyncUtil'
import {FAKTORY} from '../actionTypes'

export default reducerFactory(FAKTORY)
